import styled from 'styled-components'

const BaseSelectPanel = styled.div`
  padding: 10px 20px;
`

export default BaseSelectPanel
